<template>
  <div>
    <div class="card mb-5 shadow" v-if="this.novidades.length > 0">
      <b-card-header
        header-text-variant="white"
        header-tag="header"
        :style="cor"
        class="txtLeft"
        @click="selecionarCategoria(0)"
      >DESTAQUES</b-card-header>
      <b-card border-variant="light" class="cardNovidades">
        <b-card-text>
          <swiper :options="swiperOptionNov">
            <swiper-slide v-for="item in novidades" :key="item.codigo" @click.native="selecionarNovidade(item.codigo)">
              <template>
                <span v-if="item.url" class="imgItem"><img :src="item.url" alt=""/></span>
                <span class="semImagem" v-else><img src="@/assets/sem-imagem.png" alt="" /></span>
                <span class="itemGrade"><strong>Item:</strong> {{item.codigoGrade}}</span>
                <span class="descGrade"><strong>Descrição:</strong> {{item.descricaoGrade}}</span>
              </template>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev swiperButtonNovPrev" slot="button-prev"></div>
          <div class="swiper-button-next swiperButtonNovNext" slot="button-next"></div>
        </b-card-text>
      </b-card>
    </div>
    <div v-if="this.categorias.length > 0">
      <div class="card mb-5 shadow" v-for="(categoria, index) in this.categorias" :key="categoria.codigo">
        <b-card-header
          :header="categoria.descricaoGrade"
          header-text-variant="white"
          header-tag="header"
          :style="cor"
          class="txtLeft"
        ></b-card-header> <!--:header="header"-->
        <b-card border-variant="light" class="cardCategorias">
          <b-card-text>
            <div v-if="categoria.grades.length > 0">
              <swiper :options="swiperOptionFormat(index)" v-if="categoria.grades.length > 0">
                <swiper-slide v-for="grade in categoria.grades" :key="grade.codigoGrade" @click.native="selecionarGrade(grade)">
                  <template>
                    <span v-if="grade.urlImagemGrade" class="imgItem"><img :src="grade.urlImagemGrade" alt=""/></span>
                    <span class="semImagem" v-else><img src="@/assets/sem-imagem.png" alt="" /></span>
                    <span class="itemGrade"><strong>Item:</strong> {{grade.codigoGrade}}</span>
                    <span class="descGrade"><strong>Descrição:</strong> {{grade.descricaoGrade}}</span>
                  </template>
                </swiper-slide>
              </swiper>
            </div>
            <span v-else>
              Não há produtos nesta categoria
            </span>
            <div class="swiper-button-prev" :class="`swiperButtonCategPrev${index}`" slot="button-prev" v-if="categoria.grades.length > 0"></div>
            <div class="swiper-button-next" :class="`swiperButtonCategNext${index}`" slot="button-next" v-if="categoria.grades.length > 0"></div>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <span class="card mb-5 shadow p-3" v-else>
      Não foram encontrados produtos com os parâmetros pesquisados, por favor, tente novamente
    </span>
    <BlockUI v-if="blockUiVisibility" :message="msgBlockUi">
      <spinner-vue></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import catalogoService from '@/services/tableCatalogo'
  import { broadcastServer, operacao, modo } from '@/main'
  // import { mapState } from 'vuex'
  import spinnerVue from '@/components/items/SpinnerVue'
  export default {
    components: {
      swiper,
      swiperSlide,
      spinnerVue
    },
    props: ['header'],
    data () {
      return {
        blockUiVisibility: false,
        msgBlockUi: 'Listando itens, aguarde...',
        tabelaSelecionada: '',
        termo: '',
        novidades: [],
        categorias: [],
        gradesCategoria: [],
        swiperOptionNov: {
          slidesPerView: 5,
          spaceBetween: 15,
          freeMode: true,
          navigation: {
            nextEl: '.swiperButtonNovNext',
            prevEl: '.swiperButtonNovPrev'
          },
          breakpoints: {
            1000: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10
            }
          }
        }
        // ,
        // swiperOption: {
        //   slidesPerView: 5,
        //   spaceBetween: 15,
        //   freeMode: true,
        //   navigation: {
        //     nextEl: `.swiperButtonCategNext${index}`,
        //     prevEl: `.swiperButtonCategPrev${index}`
        //   },
        //   breakpoints: {
        //     1000: {
        //       slidesPerView: 4,
        //       spaceBetween: 10
        //     },
        //     700: {
        //       slidesPerView: 3,
        //       spaceBetween: 10
        //     },
        //     500: {
        //       slidesPerView: 2,
        //       spaceBetween: 10
        //     }
        //   }
        // }
      }
    },
    mounted () {
      catalogoService.listarNovidades().then(response => {
        let empresa = localStorage.getItem('empresaLogada')
        if (JSON.parse(empresa).identificador === 2355480534) {
          this.novidades = response.data.destaques.sort(function (a, b) {
            return a.codigo - b.codigo
          })
        } else {
          this.novidades = response.data.destaques
        }
        this.listarCategorias(this.termo)
      })
    },
    created: function () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      broadcastServer.$on('tabelaSelecionada', param => {
        this.tabelaSelecionada = param
      })
      broadcastServer.$on('filtroCatalogo', param => {
        this.termo = param
        this.listarCategorias(this.termo)
      })
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      },
      swiperOptionFormat: function (index) {
        return {
          slidesPerView: 5,
          spaceBetween: 15,
          freeMode: true,
          navigation: {
            nextEl: `.swiperButtonCategNext${index}`,
            prevEl: `.swiperButtonCategPrev${index}`
          },
          breakpoints: {
            1000: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10
            }
          }
        }
      },
      listarCategorias: function (param) {
        this.blockUiVisibility = true
        catalogoService.listarCategorias(this.termo).then(response => {
          let categorias = response.data.catalogos
          this.categorias = categorias.sort(function (a, b) {
            return a.ordem - b.ordem
          })
          let empresa = localStorage.getItem('empresaLogada')
          if (JSON.parse(empresa).identificador !== 2355480534) {
            let gradesCategoria = this.categorias.map(g => g.grades)
            this.gradesCategoria = gradesCategoria.sort(function (a, b) {
              return a.ordemGrade - b.ordemGrade
            })
          } else {
            let gradesCategoria = this.categorias.map(g => g.grades)
            this.gradesCategoria = gradesCategoria.sort(function (a, b) {
              console.log(a, b)
              return a.codigoGrade - b.codigoGrade
            })
          }
          // this.tabelaSelecionada = response.data
          // broadcastServer.$emit('tabelaSelecionada', this.tabelaSelecionada)
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      selecionarCategoria: function (categ) {
        console.log(categ)
      },
      selecionarNovidade: function (codigo) {
        if (this.tabelaSelecionada === '') {
          alert('Por favor, selecione uma tabela de preço')
          return
        } else {
          this.blockUiVisibility = true
          let param = {codigoProduto: codigo, codigoTabelaPreco: this.tabelaSelecionada.codigo}
          catalogoService.detalhesItemNovidade(param).then(response => {
            let param = {gradeProdutos: response.data, tabela: this.tabelaSelecionada}
            broadcastServer.$emit('responseGrade', param)
          }).catch(error => {
            console.log(error)
            alert('Aconteceu alguma coisa!' + error)
          }).finally(() => {
            this.blockUiVisibility = false
            let parametro = {operacao: operacao.ALTERAR, modo: modo.EDICAO}
            broadcastServer.$emit('pageViewGrade', parametro)
          })
        }
      },
      selecionarGrade: function (grade) {
        if (this.tabelaSelecionada === '') {
          alert('Por favor, selecione uma tabela de preço')
          return
        } else {
          this.blockUiVisibility = true
          let param = {codigoGrade: grade.codigoGrade, codigoTabelaPreco: this.tabelaSelecionada.codigo}
          catalogoService.detalhesItemCategoria(param).then(response => {
            let param = {gradeProdutos: response.data, tabela: this.tabelaSelecionada}
            broadcastServer.$emit('responseGrade', param)
          }).catch(error => {
            console.log(error)
            alert('Aconteceu alguma coisa!' + error)
          }).finally(() => {
            this.blockUiVisibility = false
            let parametro = {operacao: operacao.ALTERAR, modo: modo.EDICAO}
            broadcastServer.$emit('pageViewGrade', parametro)
          })
        }
      }
    }
  }
</script>
<style scoped>
  .cardNovidades .card-body,
  .cardCategorias .card-body {
    padding: 1.25rem 30px;
  }
  .card-text {
    padding: 0 15px;
  }
  .swiper-slide {
    cursor: pointer;
    border: 1px solid #eaeaea;
    padding: 5px;
  }
  .imgItem,
  .cardNovidades .semImagem,
  .cardCategorias .semImagem {
    /* min-height: 160px; */
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cardNovidades img,
  .cardCategorias img {
    max-width: 100%;
    max-height: 100%;
    /* max-height: 160px; */
    box-shadow: 5px 10px 15px -8px rgba(183, 183, 183, 0.75);
  }
  .cardNovidades .semImagem,
  .cardCategorias .semImagem {
    box-shadow: 5px 10px 15px -8px rgba(183, 183, 183, 0.75);
    padding: 10px;
    width: 88%;
    margin: 0 auto;
  }
  .cardNovidades .semImagem img,
  .cardCategorias .semImagem img {
    max-width: 100%;
    max-height: 100px;
    box-shadow: none;
  }
  .cardNovidades span.descGrade,
  .cardNovidades span.itemGrade,
  .cardCategorias span.descGrade,
  .cardCategorias span.itemGrade {
    display: block;
  }
  .cardNovidades span:nth-child(1),
  .cardCategorias span:nth-child(1) {
    margin-bottom: 5px;
  }
  .descGrade {
    height: 53px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/cardCategoriasVue.vue